import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { Documento } from '../models/documento';

@Injectable({
  providedIn: 'root'
})
export class DocumentosService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarDocumentos(tipo: number) {
    return this.http.get<Documento[]>(globals.apiUrl + '/api/Documento/Lista', {
      params: new HttpParams()
        .set('tipo', tipo.toString())
    });
  }

  consultarDocumentosComPaginacao(tipo: number, descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipo', tipo.toString());

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Documento/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdDocumento(idDocumento) {
    return this.http.get<any>(globals.apiUrl + '/api/Documento/Buscar',
      { params: new HttpParams().set('id', idDocumento) });
  }

  salvar(documento: Documento) {
    return this.http.post(globals.apiUrl + '/api/Documento/Salvar', documento);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Documento/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
